// Strap photo tiles on belt pages: a tap sets Dawn's strap dropdown and fires its change event.
document.addEventListener('click', (event) => {
  const tile = event.target.closest('[data-rt-swatch]');
  if (!tile) return;
  const wrap = tile.closest('[data-rt-swatches]');
  const select = wrap && document.getElementById(wrap.dataset.rtSwatches);
  if (!select || select.value === tile.dataset.rtSwatch) return;
  select.value = tile.dataset.rtSwatch;
  wrap.querySelectorAll('[data-rt-swatch]').forEach((b) => {
    const on = b === tile;
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on);
  });
  select.dispatchEvent(new Event('change', { bubbles: true }));
});
